define('rebrush/components/product/view/review',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem'
], function(
    $,
    _,
    Component,
    BEM
) {
    return Component.create({
        block:					null,
        linkSelector:           null,
        onClickCallback:		null,

        constructor: function() {
            this.onClickCallback = _.bind(this._onClick, this);
            this.linkSelector = '.' + BEM.buildBlockClassname('review-summary') + ' a';
        },

        $init: function() {
            this.block = BEM.block('product-view');
            this.initializeEvents();
        },

        initializeEvents: function() {
            this.block.on('click', this.linkSelector, this.onClickCallback);
        },

        _onClick: function(e) {
           var link = $(e.currentTarget),
               href = link.attr('href'),
                fragmentMatch = href.match(/#[^#]+$/),
                targetElement;

           if (fragmentMatch) {
               targetElement = $(fragmentMatch[0]);

               if (targetElement.length) {
                   e.preventDefault();

                   // mirror of `sections.js`
                   $('html, body').animate({
                       scrollTop: targetElement.offset().top + $.css(targetElement.get(0), 'padding-top', '') - BEM.block('sections-bar').outerHeight() + 1 // +1 in order to jump into the section
                   }, 300);

                   return false;
               }
           }
        },

        destructor: function() {
            if (this.block) {
                this.block.off('click', this.linkSelector, this.onClickCallback);
            }
        }
    });
});
